import styled from 'styled-components'
import {
  AppProps,
  ButtonProps,
  ContainerProps,
  InputProps,
  LabelProps,
  LinkProps,
  ParagraphProps,
  TitleProps,
  ButtonsContainerProps,
} from '@/themes/theme'

export const Page = styled.div<AppProps>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : '#FFFFFF')};
`

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;

  background-color: ${(props) => (props.$bgColor ? props.$bgColor : '#FFFFFF')};
  border-radius: ${(props) => (props.$borderRadius ? props.$borderRadius : '8px')};
  width: ${(props) => (props.$width ? props.$width : '100%')};
  max-width: ${(props) => (props.$width ? props.$width : '100%')};
  height: ${(props) => (props.$height ? props.$height : '100%')};
  box-sizing: border-box;
  margin: ${(props) => (props.$margin ? props.$margin : '0 auto')};
  border: ${(props) => (props.$border ? props.$border : 'none')};
  box-shadow: ${(props) => (props.$boxShadow ? props.$boxShadow : 'none')};
  color: ${(props) => (props.$color ? props.$color : 'black')};
`

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > div {
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &:nth-of-type(2).empty {
      border-top: 1px solid #dddddd;
      max-height: 30px;

      img {
        display: none;
      }
    }
  }
`

export const ContentContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  align-items: center;
  padding: ${(props) => (props.$padding ? props.$padding : '38px 25px')};
`

export const Title = styled.h1<TitleProps>`
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  font-size: ${(props) => (props.$fontSize ? props.$fontSize : '24px')};
  line-height: ${(props) => (props.$lineHeight ? props.$lineHeight : '36px')};
  color: ${(props) => (props.$color ? props.$color : 'black')};
`

export const Paragraph = styled.p<ParagraphProps>`
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  font-size: ${(props) => (props.$fontSize ? props.$fontSize : '14px')};
  line-height: ${(props) => (props.$lineHeight ? props.$lineHeight : '20px')};
  color: ${(props) => (props.$color ? props.$color : 'black')};
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.label<LabelProps>`
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  font-size: ${(props) => (props.$fontSize ? props.$fontSize : '14px')};
  line-height: ${(props) => (props.$lineHeight ? props.$lineHeight : '20px')};
  color: ${(props) => (props.$color ? props.$color : 'black')};
`

export const ButtonsContainer = styled.div<ButtonsContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.$flexDirection ? props.$flexDirection : 'row')};
  gap: ${(props) => (props.$gap ? props.$gap : '20px')};
  justify-content: ${(props) => (props.$justifyContent ? props.$justifyContent : 'flex-start')};
  align-items: ${(props) => (props.$alignItems ? props.$alignItems : 'stretch')};
`

export const Link = styled.a<LinkProps>`
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  font-size: ${(props) => (props.$fontSize ? props.$fontSize : '14px')};
  line-height: ${(props) => (props.$lineHeight ? props.$lineHeight : '20px')};
  color: ${(props) => (props.$color ? props.$color : 'black')};
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : 'transparent')};
  border: ${(props) => (props.$border ? props.$border : '0px')};
  border-radius: ${(props) => (props.$borderRadius ? props.$borderRadius : '0px')};
  text-decoration: ${(props) => (props.$textDecoration ? props.$textDecoration : 'none')};
  cursor: pointer;
`
